(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["related-products"]) return;
  try {
    
(() => {
  /*
   * ==========================================================
   * FINAL RELATED PRODUCT PRIORITY
   * ==========================================================
   *
   * PRODUCT TYPE MODE:
   *
   * 1. Product Type + Gender
   *
   * 2. Collection + Gender
   *    /collections/all is skipped
   *
   * 3. Vendor + Gender
   *
   * 4. Exact Shopify Product Category
   *
   *
   * Current product is excluded.
   * Duplicate products are excluded.
   */
  customElements
    .whenDefined('related-products')
    .then(() => {
      if (
        customElements.get(
          'type-first-related-products'
        )
      ) {
        return;
      }
      const PaloAltoRelatedProducts =
        customElements.get(
          'related-products'
        );
      class TypeFirstRelatedProducts
        extends PaloAltoRelatedProducts {
        async loadRelatedProducts() {
          this.relatedProducts =
            this.querySelector(
              '[data-related-products]'
            );
          if (
            !this.relatedProducts ||
            this.sourceLookupStarted
          ) {
            return;
          }
          this.sourceLookupStarted = true;
          const grid =
            this.relatedProducts.querySelector(
              '[data-type-related-grid]'
            );
          if (!grid) {
            return;
          }
          const limit =
            Math.max(
              1,
              Math.min(
                8,
                parseInt(
                  this.dataset.limit,
                  10
                ) || 4
              )
            );
          const productId =
            String(
              this.dataset.productId ||
              ''
            );
          const selectedSource =
            this.dataset.recommendationSource ||
            'product_type';
          const sourceValue =
            (
              this.dataset.sourceValue ||
              ''
            )
            .trim()
            .toLowerCase();
          const vendorValue =
            (
              this.dataset.vendorValue ||
              ''
            )
            .trim()
            .toLowerCase();
          const categoryId =
            (
              this.dataset.productCategoryId ||
              ''
            )
            .trim()
            .toLowerCase();
          const sourceUrl =
            this.dataset.sourceUrl ||
            '';
          const vendorUrl =
            this.dataset.vendorUrl ||
            '';
          const allProductsUrl =
            this.dataset.allProductsUrl ||
            '';
          /*
           * ====================================================
           * GENDER
           * ====================================================
           */
          const parseGenderTokens =
            (value) => {
              return new Set(
                (value || '')
                  .split('|')
                  .map(
                    (item) =>
                      item
                        .trim()
                        .toLowerCase()
                  )
                  .filter(Boolean)
              );
            };
          const sourceGender =
            parseGenderTokens(
              this.dataset.productGender
            );
          const shouldFilterGender =
            selectedSource === 'product_type' &&
            sourceGender.size > 0;
          const genderMatches =
            (card) => {
              if (
                !shouldFilterGender
              ) {
                return true;
              }
              const cardGender =
                parseGenderTokens(
                  card.dataset.productGender
                );
              return [...sourceGender].some(
                (gender) =>
                  cardGender.has(
                    gender
                  )
              );
            };
          /*
           * Collection candidates have already been filtered
           * server-side by gender.
           * Because fallback_collection never uses handle "all"
           * in Product Type mode, these cannot come from
           * /collections/all.
           */
          const collectionFillers =
            Array.from(
              this.relatedProducts.querySelectorAll(
                'template[data-collection-filler-card]'
              )
            );
          /*
           * ====================================================
           * FETCH SOURCE PAGE
           * ====================================================
           */
          const fetchSourcePage =
            async (
              rawUrl,
              expectedSource,
              expectedValue,
              page = 1
            ) => {
              if (!rawUrl) {
                return null;
              }
              const controller =
                new AbortController();
              const timeout =
                window.setTimeout(
                  () => controller.abort(),
                  10000
                );
              try {
                const url =
                  new URL(
                    rawUrl,
                    window.location.origin
                  );
                url.searchParams.set(
                  'section_id',
                  this.dataset.sectionId
                );
                url.searchParams.set(
                  'page',
                  String(page)
                );
                const previewThemeId =
                  new URL(
                    window.location.href
                  )
                  .searchParams
                  .get(
                    'preview_theme_id'
                  );
                if (previewThemeId) {
                  url.searchParams.set(
                    'preview_theme_id',
                    previewThemeId
                  );
                }
                const response =
                  await fetch(
                    url.toString(),
                    {
                      credentials: 'same-origin',
                      signal: controller.signal
                    }
                  );
                if (!response.ok) {
                  throw new Error(
                    `Related product lookup returned ${response.status}`
                  );
                }
                const html =
                  await response.text();
                const parsed =
                  new DOMParser()
                    .parseFromString(
                      html,
                      'text/html'
                    );
                const responseContainer =
                  parsed.querySelector(
                    '[data-source-products-response]'
                  );
                if (!responseContainer) {
                  throw new Error(
                    'Related product lookup returned no source container'
                  );
                }
                const returnedSource =
                  (
                    responseContainer.dataset.recommendationSource ||
                    ''
                  )
                  .trim()
                  .toLowerCase();
                const returnedValue =
                  (
                    responseContainer.dataset.sourceValue ||
                    ''
                  )
                  .trim()
                  .toLowerCase();
                if (
                  returnedSource !== expectedSource ||
                  returnedValue !== expectedValue
                ) {
                  throw new Error(
                    'Related product lookup returned unexpected source'
                  );
                }
                return responseContainer;
              } finally {
                window.clearTimeout(
                  timeout
                );
              }
            };
          /*
           * ====================================================
           * CREATE PALO ALTO GRID
           * ====================================================
           */
          const createFreshGrid =
            () => {
              const newGrid =
                document.createElement(
                  grid.localName
                );
              newGrid.className =
                grid.dataset.typeGridClass;
              [
                'data-type-related-grid',
                'data-type-grid-class',
                'data-columns',
                'data-aos-anchor'
              ]
              .forEach(
                (name) => {
                  if (
                    grid.hasAttribute(
                      name
                    )
                  ) {
                    newGrid.setAttribute(
                      name,
                      grid.getAttribute(
                        name
                      )
                    );
                  }
                }
              );
              newGrid.setAttribute(
                'tabindex',
                '0'
              );
              newGrid.setAttribute(
                'role',
                'group'
              );
              return newGrid;
            };
          /*
           * ====================================================
           * APPEND PRODUCT CARD
           * ====================================================
           */
          const appendTemplate =
            (
              targetGrid,
              template,
              seenIds
            ) => {
              const id =
                String(
                  template.dataset.productId ||
                  ''
                );
              if (
                !id ||
                seenIds.has(id)
              ) {
                return false;
              }
              if (
                !template.content.querySelector(
                  '[data-product-block]'
                )
              ) {
                return false;
              }
              seenIds.add(
                id
              );
              targetGrid.appendChild(
                document.importNode(
                  template.content,
                  true
                )
              );
              return true;
            };
          /*
           * ====================================================
           * SHOW GRID
           * ====================================================
           */
          const showGrid =
            (
              newGrid,
              sourceName
            ) => {
              grid.replaceWith(
                newGrid
              );
              this.relatedProducts.dataset.source =
                sourceName;
              this.relatedProducts.hidden =
                false;
              requestAnimationFrame(
                () => {
                  const slider =
                    this.relatedProducts.querySelector(
                      'grid-slider'
                    );
                  if (slider) {
                    slider.dispatchEvent(
                      new CustomEvent(
                        'theme:slider:resize',
                        {
                          bubbles: true
                        }
                      )
                    );
                  }
                }
              );
            };
          /*
           * ====================================================
           * COLLECTION SOURCE
           * ====================================================
           * Normal Collection source remains unchanged.
           */
          if (
            selectedSource === 'collection'
          ) {
            const count =
              parseInt(
                this.relatedProducts.dataset.fallbackCount,
                10
              ) || 0;
            if (
              count === 0
            ) {
              this.hideRelated();
              if (
                !this.querySelector(
                  'recently-viewed'
                )
              ) {
                this.hidden = true;
              }
              return;
            }
            this.relatedProducts.hidden =
              false;
            return;
          }
          /*
           * ====================================================
           * VENDOR SOURCE
           * ====================================================
           */
          if (
            selectedSource === 'vendor'
          ) {
            let count =
              0;
            try {
              const source =
                await fetchSourcePage(
                  sourceUrl,
                  'vendor',
                  sourceValue,
                  1
                );
              if (source) {
                const newGrid =
                  createFreshGrid();
                const seenIds =
                  new Set([
                    productId
                  ]);
                const cards =
                  Array.from(
                    source.querySelectorAll(
                      'template[data-source-product-card]'
                    )
                  );
                for (
                  const card of cards
                ) {
                  if (
                    count >= limit
                  ) {
                    break;
                  }
                  const value =
                    (
                      card.dataset.productVendor ||
                      ''
                    )
                    .trim()
                    .toLowerCase();
                  if (
                    value !== sourceValue
                  ) {
                    continue;
                  }
                  if (
                    appendTemplate(
                      newGrid,
                      card,
                      seenIds
                    )
                  ) {
                    count++;
                  }
                }
                if (
                  count > 0
                ) {
                  showGrid(
                    newGrid,
                    'vendor'
                  );
                  return;
                }
              }
            } catch (error) {
              if (
                window.Shopify &&
                window.Shopify.designMode
              ) {
                console.warn(
                  'Related products: Vendor lookup failed.',
                  error
                );
              }
            }
            this.hideRelated();
            if (
              !this.querySelector(
                'recently-viewed'
              )
            ) {
              this.hidden = true;
            }
            return;
          }
          /*
           * ====================================================
           * PRODUCT TYPE MODE
           * ====================================================
           */
          const newGrid =
            createFreshGrid();
          const seenIds =
            new Set([
              productId
            ]);
          let totalAdded =
            0;
          /*
           * ====================================================
           * PRIORITY 1
           *
           * PRODUCT TYPE + GENDER
           * ====================================================
           */
          if (
            sourceValue &&
            sourceUrl &&
            totalAdded < limit
          ) {
            try {
              const typeSource =
                await fetchSourcePage(
                  sourceUrl,
                  'product_type',
                  sourceValue,
                  1
                );
              if (typeSource) {
                const cards =
                  Array.from(
                    typeSource.querySelectorAll(
                      'template[data-source-product-card]'
                    )
                  );
                for (
                  const card of cards
                ) {
                  if (
                    totalAdded >= limit
                  ) {
                    break;
                  }
                  const value =
                    (
                      card.dataset.productType ||
                      ''
                    )
                    .trim()
                    .toLowerCase();
                  if (
                    value !== sourceValue
                  ) {
                    continue;
                  }
                  if (
                    !genderMatches(
                      card
                    )
                  ) {
                    continue;
                  }
                  if (
                    appendTemplate(
                      newGrid,
                      card,
                      seenIds
                    )
                  ) {
                    totalAdded++;
                  }
                }
              }
            } catch (error) {
              if (
                window.Shopify &&
                window.Shopify.designMode
              ) {
                console.warn(
                  'Related products: Product Type + Gender lookup failed.',
                  error
                );
              }
            }
          }
          /*
           * ====================================================
           * PRIORITY 2
           *
           * COLLECTION + GENDER
           *
           * IMPORTANT:
           *
           * fallback_collection never uses /collections/all
           * automatically in Product Type mode.
           * ====================================================
           */
          if (
            totalAdded < limit
          ) {
            for (
              const filler of collectionFillers
            ) {
              if (
                totalAdded >= limit
              ) {
                break;
              }
              if (
                appendTemplate(
                  newGrid,
                  filler,
                  seenIds
                )
              ) {
                totalAdded++;
              }
            }
          }
          /*
           * ====================================================
           * PRIORITY 3
           *
           * VENDOR + GENDER
           * ====================================================
           */
          if (
            totalAdded < limit &&
            vendorUrl &&
            vendorValue
          ) {
            try {
              const vendorSource =
                await fetchSourcePage(
                  vendorUrl,
                  'vendor',
                  vendorValue,
                  1
                );
              if (
                vendorSource
              ) {
                const vendorCards =
                  Array.from(
                    vendorSource.querySelectorAll(
                      'template[data-source-product-card]'
                    )
                  );
                for (
                  const card of vendorCards
                ) {
                  if (
                    totalAdded >= limit
                  ) {
                    break;
                  }
                  const value =
                    (
                      card.dataset.productVendor ||
                      ''
                    )
                    .trim()
                    .toLowerCase();
                  if (
                    value !== vendorValue
                  ) {
                    continue;
                  }
                  if (
                    !genderMatches(
                      card
                    )
                  ) {
                    continue;
                  }
                  if (
                    appendTemplate(
                      newGrid,
                      card,
                      seenIds
                    )
                  ) {
                    totalAdded++;
                  }
                }
              }
            } catch (error) {
              if (
                window.Shopify &&
                window.Shopify.designMode
              ) {
                console.warn(
                  'Related products: Vendor + Gender fallback failed.',
                  error
                );
              }
            }
          }
          /*
           * ====================================================
           * PRIORITY 4
           *
           * EXACT SHOPIFY PRODUCT CATEGORY
           * ====================================================
           * /collections/all is used here only as a catalog
           * search endpoint.
           * It is NOT being treated as Collection fallback.
           * Gender is not required on this final level.
           * Maximum catalog scan:
           * 10 pages x 50 products = 500 products.
           */
          if (
            totalAdded < limit &&
            allProductsUrl &&
            categoryId
          ) {
            try {
              let page =
                1;
              let totalPages =
                1;
              const maxPagesToCheck =
                10;
              while (
                totalAdded < limit &&
                page <= totalPages &&
                page <= maxPagesToCheck
              ) {
                const allSource =
                  await fetchSourcePage(
                    allProductsUrl,
                    'all',
                    'all',
                    page
                  );
                if (
                  !allSource
                ) {
                  break;
                }
                totalPages =
                  Math.max(
                    1,
                    parseInt(
                      allSource.dataset.totalPages,
                      10
                    ) || 1
                  );
                const allCards =
                  Array.from(
                    allSource.querySelectorAll(
                      'template[data-source-product-card]'
                    )
                  );
                for (
                  const card of allCards
                ) {
                  if (
                    totalAdded >= limit
                  ) {
                    break;
                  }
                  const candidateCategoryId =
                    (
                      card.dataset.productCategoryId ||
                      ''
                    )
                    .trim()
                    .toLowerCase();
                  if (
                    !candidateCategoryId ||
                    candidateCategoryId !== categoryId
                  ) {
                    continue;
                  }
                  if (
                    appendTemplate(
                      newGrid,
                      card,
                      seenIds
                    )
                  ) {
                    totalAdded++;
                  }
                }
                page++;
              }
            } catch (error) {
              if (
                window.Shopify &&
                window.Shopify.designMode
              ) {
                console.warn(
                  'Related products: Exact Shopify Product Category fallback failed.',
                  error
                );
              }
            }
          }
          /*
           * ====================================================
           * FINAL RESULT
           * ====================================================
           */
          if (
            totalAdded > 0
          ) {
            showGrid(
              newGrid,
              'product_type_fallback_chain'
            );
            return;
          }
          this.hideRelated();
          if (
            !this.querySelector(
              'recently-viewed'
            )
          ) {
            this.hidden = true;
          }
        }
      }
      customElements.define(
        'type-first-related-products',
        TypeFirstRelatedProducts
      );
    });
})();

  } catch(e) { console.error(e); }
})();
})();
